import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import './style/global.less';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import axios from 'axios';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import './mock';
import { userInfoUrl } from './http/api';
import { getToken } from './http/conmon';
const store = createStore(rootReducer);
const token = getToken();
function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'en-US');
  const [theme, setTheme] = useStorage('arco-theme', 'light');
  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return zhCN;
    }
  }
  function fetchUserInfo() {
    store.dispatch({
      type: 'update-userInfo',
      payload: {
        userLoading: true
      }
    });
    axios.get(`${userInfoUrl}`, {
      headers: {
        Authorization: `Bearer ${token}` // 将 token 添加到 headers 中
      }
    }).then(res => {
      const info = res.data.value;
      if (info?.role) {
        localStorage.setItem('userRole', info.role);
      }
      if (info?.team) {
        localStorage.setItem('userTeam', info.team);
      }
      store.dispatch({
        type: 'update-userInfo',
        payload: {
          userInfo: info,
          userLoading: false
        }
      });
    }).catch(error => {
      if (error.response.status === 401) {
        _Message.info('登录超时, 请重新登录');
        localStorage.clear();
        // 延迟关闭提示消息
        setTimeout(() => {
          _Message.clear(); // 清除提示消息
          window.location.pathname = '/login';
        }, 1000); // 设置延迟时间（单位：毫秒）
      } else {
        _Message.error(error.message);
      }
    });
  }
  useEffect(() => {
    if (checkLogin()) {
      fetchUserInfo();
    } else if (window.location.pathname.replace(/\//g, '') !== 'login') {
      window.location.pathname = '/login';
    }
  }, []);
  useEffect(() => {
    changeTheme(theme);
  }, [theme]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getArcoLocale(),
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: PageLayout
  }))))));
}
ReactDOM.render( /*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));